export const baseMenuShortcutConfig = {
  shiftKey: true,
  altKey: true,
} as const;

export const baseNavigationShortcutConfig = {
  altKey: true,
} as const;
